module.exports = __webpack_public_path__ + "media/images/application/cdao-bg-59a981d2bfcb82aa54d8388486ff7456.png";